import { render, staticRenderFns } from "./ForgeViewer.vue?vue&type=template&id=f3fa1c24&scoped=true"
import script from "./ForgeViewer.vue?vue&type=script&lang=js"
export * from "./ForgeViewer.vue?vue&type=script&lang=js"
import style0 from "./ForgeViewer.vue?vue&type=style&index=0&id=f3fa1c24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3fa1c24",
  null
  
)

export default component.exports